import { groupApi } from '@/api/groupManagement';

const state = {
  groups: []
}

const mutations = {
  SET_GROUPS(state, groups) {
    state.groups = groups
  },
  ADD_GROUP(state, group) {
    state.groups.push(group)
  },
  UPDATE_GROUP(state, updatedGroup) {
    const index = state.groups.findIndex(group => group.id === updatedGroup.id)
    if (index !== -1) {
      state.groups.splice(index, 1, updatedGroup)
    }
  },
  REMOVE_GROUP(state, groupId) {
    state.groups = state.groups.filter(group => group.id !== groupId)
  }
}

const actions = {
  async fetchGroups({ commit }) {
    try {
      const groups = await groupApi.getAllGroups();
      commit('SET_GROUPS', groups);
    } catch (error) {
      console.error('Error fetching groups:', error);
    }
  },
  async addGroup({ commit }, group) {
    try {
      const newGroup = await groupApi.createGroup(group);
      commit('ADD_GROUP', newGroup);
      return newGroup;
    } catch (error) {
      console.error('Error adding group:', error);
      throw error;
    }
  },
  async updateGroup({ commit }, group) {
    try {
      const updatedGroup = await groupApi.updateGroup(group.id, group);
      commit('UPDATE_GROUP', updatedGroup);
      return updatedGroup;
    } catch (error) {
      console.error('Error updating group:', error);
      throw error;
    }
  },
  async removeGroup({ commit }, groupId) {
    try {
      await groupApi.deleteGroup(groupId);
      commit('REMOVE_GROUP', groupId);
    } catch (error) {
      console.error('Error removing group:', error);
      throw error;
    }
  }
}

const getters = {
  getGroups: state => state.groups
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

